import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FaChevronDown, FaChevronUp, FaFilter } from 'react-icons/fa';

const Wrapper = styled.div`
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  background: var(--color-bg-primary);
  border: 1px solid var(--color-border-primary);
  border-radius: 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  /* visible: dropdowns do FieldFilter não podem ser cortados */
  overflow: visible;
`;

const ToggleButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  width: 100%;
  padding: 0.75rem 1rem;
  border: none;
  border-radius: 12px 12px 0 0;
  background: var(--color-light);
  color: var(--color-text-primary);
  cursor: pointer;
  font-family: inherit;
  font-size: 0.9rem;
  font-weight: 600;
  text-align: left;

  &:hover {
    background: var(--color-hover-overlay, var(--color-light));
  }

  &:focus-visible {
    outline: 2px solid var(--color-secondary);
    outline-offset: -2px;
  }
`;

const ToggleLeft = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 0;
`;

const FilterIcon = styled(FaFilter)`
  font-size: 0.85rem;
  color: var(--color-text-secondary);
  flex-shrink: 0;
`;

const ActiveBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.35rem;
  height: 1.35rem;
  padding: 0 0.35rem;
  border-radius: 999px;
  background: var(--color-btn-primary-bg, #404040);
  color: var(--color-btn-primary-text, #fff);
  font-size: 0.7rem;
  font-weight: 700;
  line-height: 1;
`;

const Chevron = styled.span`
  display: inline-flex;
  color: var(--color-text-secondary);
  font-size: 0.75rem;
  flex-shrink: 0;
`;

const Panel = styled.div`
  display: ${({ $open }) => ($open ? 'block' : 'none')};
  padding: 0.85rem 1rem 1rem;
  border-top: 1px solid var(--color-border-primary);
  overflow: visible;
  position: relative;
  z-index: 5;
`;

const CollapsibleFilters = ({
  children,
  activeCount = 0,
  title = 'Filtros',
  className,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <Wrapper className={className}>
      <ToggleButton
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        aria-expanded={open}
      >
        <ToggleLeft>
          <FilterIcon aria-hidden />
          {title}
          {activeCount > 0 && (
            <ActiveBadge aria-label={`${activeCount} filtros ativos`}>
              {activeCount}
            </ActiveBadge>
          )}
        </ToggleLeft>
        <Chevron aria-hidden>{open ? <FaChevronUp /> : <FaChevronDown />}</Chevron>
      </ToggleButton>
      <Panel $open={open}>{children}</Panel>
    </Wrapper>
  );
};

CollapsibleFilters.propTypes = {
  children: PropTypes.node.isRequired,
  activeCount: PropTypes.number,
  title: PropTypes.string,
  className: PropTypes.string,
};

export default CollapsibleFilters;
